<template>
  <div class="container-brains-radio-button" :class="['radio-' + width]">
    <div class="radio" :class="['radio-direction-' + direction, 'radio-' + width, { 'radio--selected': vModel === inputValue } ]">
      <label class="radio-label" :for="brainsRadioId">{{ label }}</label>
      <input :id="brainsRadioId" v-model="vModel" type="radio" :value="inputValue" hidden>
      <span :class="{ 'fake-radio-btn--selected': vModel === inputValue }" class="fake-radio-btn" @click="vModel = inputValue" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'BrainsRadioButton',
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: 'Label'
    },
    inputValue: {
      type: String,
      default: 'value'
    },
    direction: {
      type: String,
      default: 'right'
    },
    width: {
      type: String,
      default: 'full-width'
    }
  },
  data() {
    return {
      vModel: this.value
    }
  },
  computed: {
    brainsRadioId() {
      return 'brains-radio-' + this.randomNum + '-' + this.inputValue
    }
  },
  watch: {
    value() {
      this.vModel = this.value
    },
    vModel(newOne, oldOne) {
      this.handleInput()
    }
  },
  created() {
    this.generateRandomNum()
  },
  methods: {
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    handleInput(e) {
      this.$emit('input', this.vModel)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.radio-full-width {
  width: 100%;
}

.radio-no-full-width {
  display: inline-flex;

  .radio label {
    margin-right: 10px;
  }
}

.container-brains-radio-button {

  .radio {
    display: flex;
    justify-content: space-between;
    align-items: center;

    label {
      cursor: pointer;
      font-size: 14px;

      &:hover ~ .fake-radio-btn {
        border-color: $primary-brains;
      }
    }

    &--selected {
      color: $primary-brains;
      font-family: 'Montserrat-SemiBold',sans-serif;
    }

    .fake-radio-btn {
      border: 2px solid #333333;
      width: 16px;
      height: 16px;
      border-radius: 20px;
      cursor: pointer;

      &--selected {
        background-color: $primary-brains;
      }

      &:hover {
        border-color: $primary-brains;
      }
    }
  }

  .radio-direction- {
    &left {
      flex-direction: row-reverse;
    }
  }
}
</style>
